import React, { useState } from "react";
import PropTypes from "prop-types";
import { DropDown, Loader, Modal, ImageWithRetry } from "@src/components/atoms";
import AppUtils from "@src/utils/appUtils";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

const AccountExamplesCard = ({
  industry,
  title,
  expand,
  exampleDropdownOnChange,
  exampleScreenOptions,
  exampleScreenImage,
  isLoading = false,
}) => {
  const [modelOpen, setModalOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const image = (
    <ImageWithRetry
      src={`https://signol-email-images.s3.eu-west-2.amazonaws.com/web_app_examples/${industry}/${exampleScreenImage}.png`}
      alt={`${exampleScreenImage} sample email`}
    />
  );

  return (
    <div className="pt-8 px-12">
      <div className="font-bold md:font-extrabold text-base md:text-lg text-neutral-500 mb-4">
        {title}
      </div>
      <div className="w-1/2 mb-8">
        <DropDown
          options={exampleScreenOptions}
          value={exampleScreenImage}
          onChange={exampleDropdownOnChange}
        />
      </div>
      <div
        className="w-full overflow-hidden flex justify-center"
        style={{ height: "350px" }}
      >
        {isLoading ? (
          <div className="w-full h-full flex align-center">
            <Loader size="2xl" />
          </div>
        ) : (
          <>
            <Modal
              size="fullscreen"
              open={modelOpen}
              handleClose={() => {
                setModalOpen(false);
              }}
            >
              <div className="flex flex-col items-center">
                <div className="w-1/2 mb-8 pt-8">
                  <DropDown
                    options={exampleScreenOptions}
                    value={exampleScreenImage}
                    onChange={exampleDropdownOnChange}
                  />
                </div>
                <div className="border-2 border-gray-200 relative mx-6">
                  {image}
                </div>
              </div>
            </Modal>
            <div
              className="border-2 border-gray-200 relative"
              onClick={() => {
                setModalOpen(true);
              }}
              onMouseEnter={() => {
                setShowTooltip(true);
              }}
              onMouseLeave={() => {
                setShowTooltip(false);
              }}
            >
              {showTooltip && (
                <div className="absolute w-full h-full flex justify-center items-center cursor-pointer">
                  <div className="py-3 px-4 bg-neutral-300 shadow text-sm text-black font-medium">
                    {expand}
                  </div>
                </div>
              )}
              {image}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export const accountExamplesCardControls = {
  industry: COMMON_CONTROLS.industry,
  title: {
    propType: PropTypes.string,
    controlType: "text",
  },
  expand: {
    propType: PropTypes.string,
    controlType: "text",
    description: "Hover text to prompt to click",
  },
  exampleScreenOptions: {
    propType: PropTypes.array,
    disable: true,
  },
  exampleScreenImage: {
    propType: PropTypes.string,
    controlType: "text",
    description: "initial value",
  },
  exampleDropdownOnChange: {
    propType: PropTypes.func,
    disable: true,
  },
  isLoading: COMMON_CONTROLS.isLoading,
};
AccountExamplesCard.propTypes = AppUtils.getPropTypeFromControls(
  accountExamplesCardControls,
);

export default AccountExamplesCard;
